var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 0.625H4.33268C2.04102 0.625 0.166016 2.5 0.166016 4.79167V5.83333C0.166016 6.45833 0.582682 6.875 1.20768 6.875H24.1243C24.7493 6.875 25.166 6.45833 25.166 5.83333V4.79167C25.166 2.5 23.291 0.625 20.9993 0.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1243 8.95703H1.20768C0.582682 8.95703 0.166016 9.3737 0.166016 9.9987V15.207C0.166016 17.4987 2.04102 19.3737 4.33268 19.3737H20.9993C23.291 19.3737 25.166 17.4987 25.166 15.207V9.9987C25.166 9.3737 24.7493 8.95703 24.1243 8.95703ZM11.6243 16.2487H5.37435C4.74935 16.2487 4.33268 15.832 4.33268 15.207C4.33268 14.582 4.74935 14.1654 5.37435 14.1654H11.6243C12.2493 14.1654 12.666 14.582 12.666 15.207C12.666 15.832 12.2493 16.2487 11.6243 16.2487ZM19.9577 13.1237H17.8743C17.2493 13.1237 16.8327 12.707 16.8327 12.082C16.8327 11.457 17.2493 11.0404 17.8743 11.0404H19.9577C20.5827 11.0404 20.9993 11.457 20.9993 12.082C20.9993 12.707 20.5827 13.1237 19.9577 13.1237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.d88a69023ac6c6a75a6c66377d56a811.svg";
export { ForwardRef as ReactComponent };